<app-header></app-header>
<app-main></app-main>
<app-about></app-about>
<app-skills></app-skills>
<app-qualification></app-qualification>
<app-portfolio></app-portfolio>
<app-project-in-mind></app-project-in-mind>
<app-contact-me></app-contact-me>
<app-footer></app-footer>
